import $ from 'jquery';
import 'select2';

$('select').select2({
    width: '100%',
    minimumResultsForSearch: -1, // disable search box
});
